import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-faculty-name-popup',
  templateUrl: './faculty-name-popup.component.html',
  styleUrls: ['./faculty-name-popup.component.scss'],
})
export class FacultyNamePopupComponent  implements OnInit {

  addFacultyForm!: FormGroup;
   buttonColorName: any;
 
 
 
   constructor(private fb: FormBuilder, private dialog: MatDialog, public dialogRef: MatDialogRef<FacultyNamePopupComponent> ) { 
      this.buttonColorName = sessionStorage.getItem('buttonColorName');
   }
 
   ngOnInit() {
    // Prefilled Form Data
    this.addFacultyForm = this.fb.group({
      facultyName: [{ value: 'John Doe', disabled: true }, Validators.required], // Readonly
      contactNumber: [{ value: '9876543210', disabled: true }, [Validators.required, Validators.pattern(/^\d{10}$/)]],
      email: [{ value: 'johndoe@example.com', disabled: true }, [Validators.required, Validators.email]],
      details: [{ value: 'Expert in AI and ML', disabled: true }, Validators.required],
      link: [{ value: 'https://facultyprofile.com/johndoe', disabled: true }, Validators.required]
    });
  }


 
 
 
 closeDialog() {
   this.dialogRef.close();
 }
}
